import { shell } from '../../shell/shellClasses';
import { BlockCsvButton } from '../debug-export/BlockCsvButton';
import { executiveKpiCalcCsv } from '../debug-export/blockCsv';
import { downloadCsv } from '../debug-export/csv';
import { KpiCard } from './KpiCard';
import type { ExecutiveKpiStripModel } from './types';

export function ExecutiveKpiStrip({
  model,
  loading,
  error,
  onRetry,
}: {
  model: ExecutiveKpiStripModel | null;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}) {
  return (
    <section
      id="widget-executive-kpis"
      data-widget-id="executive-kpis"
      aria-labelledby="executive-kpi-heading"
      className="space-y-4"
    >
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <h2
          id="executive-kpi-heading"
          className="text-sm font-semibold tracking-tight text-[var(--shell-fg)]"
        >
          Business pulse
          {model ? (
            <span className={`ml-2 font-normal ${shell.muted}`}>
              {model.periodLabel}
              {model.priorLabel !== 'No compare' ? ` vs ${model.priorLabel}` : ''}
            </span>
          ) : null}
        </h2>
        <BlockCsvButton
          disabled={!model}
          onClick={() => {
            if (!model) return;
            downloadCsv(
              `dashboard_executive-kpis_${model.from}_${model.to}.csv`,
              executiveKpiCalcCsv(model),
            );
          }}
        />
      </div>

      {error && (
        <div
          role="alert"
          className="rounded-[var(--shell-radius-md)] bg-[var(--shell-danger)]/10 px-3 py-2 text-sm text-[var(--shell-danger)]"
        >
          {error}{' '}
          <button type="button" className="underline" onClick={onRetry}>
            Try again
          </button>
        </div>
      )}

      {loading && !model ? (
        <div
          className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5"
          aria-busy="true"
          aria-label="Loading executive KPIs"
        >
          {Array.from({ length: 10 }).map((_, i) => (
            <div
              key={i}
              className="h-[148px] animate-pulse rounded-[var(--shell-radius-md)] bg-[var(--shell-hover)] motion-reduce:animate-none"
            />
          ))}
        </div>
      ) : model ? (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {model.kpis.map((kpi) => (
            <KpiCard key={kpi.id} kpi={kpi} />
          ))}
        </div>
      ) : null}
    </section>
  );
}
